module.exports = __webpack_public_path__ + "static/edit-product-bought-together-75b2edfdbcbadc820046da25f3e2d92f.png";